import axios from 'axios';

import { IPaymentMethod, TOktaApiResponse } from '../interfaces';

import destructureAxiosReq from './destructureAxiosReq';
import sureAxios from './sureAxios';

export function setSDKAuthHeader(accessToken: string) {
  sureAxios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
}

export function deleteSDKAuthHeader() {
  delete sureAxios.defaults.headers.common.Authorization;
}

const api = {
  oktaAuthenticate(opts: {
    username: string;
    password: string;
    options: Record<string, any>;
    context?: Record<string, any>;
  }) {
    const BASE_OKTA_URL = (process.env.REACT_APP_OKTA_ISSUER || '').split(
      '/oauth2'
    )[0];
    return destructureAxiosReq<TOktaApiResponse>(
      axios.post(`${BASE_OKTA_URL}/api/v1/authn`, opts)
    );
  },

  oktaResetPassword(opts: {
    username: string;
    factorType: string;
    context?: Record<string, any>;
  }) {
    const BASE_OKTA_URL = (process.env.REACT_APP_OKTA_ISSUER || '').split(
      '/oauth2'
    )[0];
    return destructureAxiosReq<TOktaApiResponse>(
      axios.post(`${BASE_OKTA_URL}/api/v1/authn/recovery/password`, opts)
    );
  },

  oktaValidateRecoveryToken(opts: {
    recoveryToken: string;
    context?: Record<string, any>;
  }) {
    const BASE_OKTA_URL = (process.env.REACT_APP_OKTA_ISSUER || '').split(
      '/oauth2'
    )[0];
    return destructureAxiosReq<TOktaApiResponse>(
      axios.post(`${BASE_OKTA_URL}/api/v1/authn/recovery/token`, opts)
    );
  },

  oktaPostRequest({
    url,
    opts = {},
  }: {
    url: string;
    opts: Record<string, any>;
  }) {
    return destructureAxiosReq<TOktaApiResponse>(axios.post(url, opts));
  },

  changePassword(newPassword: string, oldPassword: string) {
    return destructureAxiosReq(
      sureAxios.post(`/api/user/v1/change-password`, {
        old_password: oldPassword,
        new_password: newPassword,
      })
    );
  },

  createPaymentMethod(opts: {
    token?: string;
    email: string;
    name: string;
    gatewayReferenceId?: string;
    paymentServiceId?: string;
  }) {
    const payload: {
      source_token?: string;
      email: string;
      name: string;
      gateway_reference_id?: string;
      payment_service_id?: string;
    } = {
      email: opts.email,
      name: opts.name,
    };
    if (opts.gatewayReferenceId) {
      payload.gateway_reference_id = opts.gatewayReferenceId;
      payload.payment_service_id = opts.paymentServiceId;
    }
    if (opts.token) {
      payload.source_token = opts.token;
    }
    return destructureAxiosReq<IPaymentMethod>(
      sureAxios.post(`/api/management/v1/payment_methods`, payload)
    );
  },

  exchangeVgsToken(opts: {
    type: string;
    cardNumberToken: string;
    expMonth: string;
    expYear: string;
    cvcToken: string;
    carrierCode: string;
    paymentApiAuthToken: string;
  }) {
    return destructureAxiosReq<{ gateway_reference_id: string; id: string }>(
      axios.post(
        `${process.env.REACT_APP_SURE_PAYMENTS_API_URL}api/payment-methods/`,
        {
          payment_method: {
            type: opts.type,
            number: opts.cardNumberToken,
            exp_month: opts.expMonth,
            exp_year: opts.expYear,
            cvc: opts.cvcToken,
          },
          carrier: {
            code: opts.carrierCode,
          },
        },
        {
          headers: {
            Authorization: `Bearer ${opts.paymentApiAuthToken}`,
          },
        }
      )
    );
  },
};

export default api;
